import React, { ReactElement, ReactNode, useState } from 'react';

import { createTheme, ThemeProvider, Tooltip as MaterialTooltip } from '@mui/material';
import { TooltipProps } from '@mui/material/Tooltip/Tooltip';

interface TooltipWrapperProps extends TooltipProps {
  title: ReactNode;
  children: ReactElement;
  isOpen?: boolean;
  tooltipRef?: React.Ref<HTMLInputElement>;
}

const getTheme = () => {
  return createTheme({
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontFamily: 'Poppins',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '16px',
            lineHeight: '22px',
            padding: '10px',
            color: '#2C3D50',
            backgroundColor: '#ffffff',
            whiteSpace: 'pre-wrap',
            border: '1px solid #2C3D50',
            borderRadius: '5px',
            maxWidth: '360px',
            margin: '5px !important',
          },
          arrow: {
            '&::before': {
              border: '1px solid #2C3D50',
              backgroundColor: '#fff',
              boxSizing: 'border-box',
            },
          },
        },
      },
    },
  });
};

const DELAY_BEFORE_CLOSE = 5000;

const Tooltip = ({ title, children, isOpen = false, tooltipRef, ...restProps }: TooltipWrapperProps) => {
  const [open, setOpen] = useState(isOpen);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    if (title) {
      setOpen(true);
    }
  };

  return (
    <ThemeProvider theme={getTheme()}>
      <MaterialTooltip
        onMouseOver={handleTooltipOpen}
        onTouchStart={handleTooltipOpen}
        onClose={handleTooltipClose}
        onClick={handleTooltipOpen}
        open={open}
        placement={'right'}
        arrow
        title={title}
        leaveTouchDelay={DELAY_BEFORE_CLOSE}
        ref={tooltipRef}
        {...restProps}
      >
        {children}
      </MaterialTooltip>
    </ThemeProvider>
  );
};

export default Tooltip;
